
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Team } from "../../types";

interface AssignedTeamsProps {
  guardTeams: Team[];
  isLoading: boolean;
}

export const AssignedTeams = ({ guardTeams, isLoading }: AssignedTeamsProps) => {
  return (
    <div className="mt-4">
      <p className="font-medium mb-2 text-center">Assigned Teams:</p>
      <div className="flex flex-wrap justify-center gap-2">
        {isLoading ? (
          <Skeleton className="h-6 w-24" />
        ) : guardTeams && guardTeams.length > 0 ? (
          guardTeams.map((team) => (
            <Button 
              key={team.id} 
              variant="default"
              className="bg-primary text-white h-10 text-sm w-full mt-2"
            >
              {team.name}
            </Button>
          ))
        ) : (
          <span className="text-sm text-muted-foreground text-center w-full">No teams assigned</span>
        )}
      </div>
    </div>
  );
};
